/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { Provider as ReduxProvider } from 'react-redux';
import { Store } from 'redux';

import i18next from 'i18next';

import './provider.scss';

import AccessibilityListener from '../accessibility-listener';

export interface Props {
  store: Store<any>;
  i18n: i18next.i18n;
}

interface ProviderProps extends Props {
  content: JSX.Element;
}

interface ProviderState {
  renderKey: null | number;
}

class Provider extends React.Component<ProviderProps, ProviderState> {
  state = {
    renderKey: null,
  };

  componentDidMount() {
    this.setState({ renderKey: new Date().getTime() });
  }

  render() {
    const renderKey = this.state.renderKey ?? 0;

    return (
      <ReduxProvider store={this.props.store}>
        <I18nextProvider i18n={this.props.i18n}>
          <div>
            <AccessibilityListener />
            <React.Fragment key={this.state.renderKey}>
              {renderKey > 0 && React.cloneElement(this.props.content)}
            </React.Fragment>
          </div>
        </I18nextProvider>
      </ReduxProvider>
    );
  }
}

const ProviderFactory = (content: JSX.Element) => {
  return ({ store, i18n }: Props) => <Provider store={store} i18n={i18n} content={content} />;
};

export default ProviderFactory;
